import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./HouseDetails.scss";
import axios from "axios";
import { IoIosAdd } from "react-icons/io";
import { FaSearch } from "react-icons/fa";
import { LuFileEdit } from "react-icons/lu";
import { FaRegTrashCan } from "react-icons/fa6";
import { IoIosAddCircleOutline } from "react-icons/io";
import { ImCross } from "react-icons/im";
import Pagination from "../../utils/Pagination";
import {
  deleteHouseDetail,
  fetchHouseDetailById,
  fetchHouseDetails,
  updateHouseDetail,
  fetchPanchayats,
  fetchBlocks,
  fetchCategories,
  fetchYears,
  fetchSchemesData,
} from "../../services/api";
import AlertMsg from "../../components/AlertMsg/AlertMsg";
import Loading from "../../components/Loading/Loading";
import { RiSortAlphabetAsc, RiSortAlphabetDesc } from "react-icons/ri";

const HouseDetails = () => {
  const [houseDetailsData, setHouseDetailsData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [editBlock, setEditBlock] = useState(null);
  const [viewBlockDetails, setViewBlockDetails] = useState(null);
  const [blockToDelete, setBlockToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sortAscending, setSortAscending] = useState(true);
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [formData, setFormData] = useState({
    regNo: "",
    yearId: 0,
    schemeId: 0,
    blockId: 0,
    villageId: 0,
    panchayatId: 0,
    fatherorHusband: "",
    beneficiary: "",
    sanctionNo: "",
    categoryId: 0,
    releasedAmount: 0,
    installment: 0,
    creditDate: getCurrentDate(),
    houseStatusId: null,
    activeStatus: true,
  });
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const validateForm = () => {
    let tempErrors = {};
    let isValid = true;

    if (!formData.regNo.trim()) {
      tempErrors.regNo = "Registration number is required.";
      isValid = false;
    }

    if (!formData.yearId) {
      tempErrors.yearId = "Year ID must be greater than 0.";
      isValid = false;
    }
    if (!formData.schemeId) {
      tempErrors.schemeId = "scheme must be greater than 0.";
      isValid = false;
    }

    if (!formData.blockId) {
      tempErrors.blockId = "Block ID must be greater than 0.";
      isValid = false;
    }

    if (!formData.villageId) {
      tempErrors.villageId = "Village ID must be greater than 0.";
      isValid = false;
    }

    if (!formData.panchayatId) {
      tempErrors.panchayatId = "Panchayat ID must be greater than 0.";
      isValid = false;
    }

    if (!formData.fatherorHusband.trim()) {
      tempErrors.fatherorHusband = "Father or Husband name is required.";
      isValid = false;
    }

    if (!formData.beneficiary.trim()) {
      tempErrors.beneficiary = "Beneficiary name is required.";
      isValid = false;
    }

    if (!formData.sanctionNo) {
      tempErrors.sanctionNo = "Sanction number is required.";
      isValid = false;
    }

    if (!formData.categoryId) {
      tempErrors.categoryId = "Category ID must be greater than 0.";
      isValid = false;
    }

    // if (!formData.releasedAmount) {
    //   tempErrors.releasedAmount = "Released amount must be greater than 0.";
    //   isValid = false;
    // }

    // if (!formData.installment) {
    //   tempErrors.installment = "Installment must be greater than 0.";
    //   isValid = false;
    // }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };
  const [selectedBlockId, setSelectedBlockId] = useState("");
  const [selectedYearId, setSelectedYearId] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedPanchayatId, setSelectedPanchayatId] = useState("");
  const [selectedSchemesId, setSelectedSchemesId] = useState("");

  const [panchayatOptions, setPanchayatOptions] = useState([]);
  const [blockOptions, setBlockOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [schemesOptions, setSchemesOptions] = useState([]);

  const [houseToDelete, setHouseToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const blocksPerPage = 10;
  const history = useHistory();

  const fetchHouseDetailsData = async () => {
    setLoading(true);
    try {
      const response = await fetchHouseDetails();
      setHouseDetailsData(response.data);
    } catch (error) {
      console.error("Error fetching house details data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchHouseDetailsData();
  }, []);

  const fetchPanchayat = async () => {
    try {
      const response = await fetchPanchayats();
      setPanchayatOptions(response.data);
    } catch (error) {
      console.error("Error fetching panchayats data:", error);
    }
  };
  const fetchSchemes = async () => {
    try {
      const response = await fetchSchemesData();
      setSchemesOptions(response.data);
    } catch (error) {
      console.error("Error fetching scheme data:", error);
    }
  };
  const fetchBlock = async () => {
    try {
      const response = await fetchBlocks();
      setBlockOptions(response.data);
    } catch (error) {
      console.error("Error fetching panchayats data:", error);
    }
  };
  const fetchYear = async () => {
    try {
      const response = await fetchYears();
      setYearOptions(response.data);
    } catch (error) {
      console.error("Error fetching panchayats data:", error);
    }
  };
  const fetchCategory = async () => {
    try {
      const response = await fetchCategories();
      setCategoryOptions(response.data);
    } catch (error) {
      console.error("Error fetching panchayats data:", error);
    }
  };
  useEffect(() => {
    fetchBlock();
    fetchYear();
    fetchCategory();
    fetchPanchayat();
    fetchSchemes();
  }, []);

  const handleSortByName = () => {
    setSortAscending(!sortAscending); // Toggle sorting order
  };
  const filteredBlocks = houseDetailsData
    .filter(
      (block) =>
        block.beneficiary &&
        block.beneficiary.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (sortAscending) {
        return a.beneficiary.localeCompare(b.beneficiary); // Ascending order
      } else {
        return b.beneficiary.localeCompare(a.beneficiary); // Descending order
      }
    });

  const pageCount = Math.ceil(filteredBlocks.length / blocksPerPage);

  const getCurrentPageBlocks = () => {
    const startIndex = currentPage * blocksPerPage;
    const endIndex = startIndex + blocksPerPage;
    return filteredBlocks.slice(startIndex, endIndex);
  };

  const handleMoveDetails = () => {
    history.push("/add-house-details");
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "activeStatus" ? value === "true" : value;
    setFormData({
      ...formData,
      [name]: newValue,
    });
  };
  const handlePanchayatChange = (e) => {
    const selectedId = e.target.value;
    setSelectedPanchayatId(selectedId);
    setFormData((prevData) => ({
      ...prevData,
      panchayatId: selectedId,
    }));
  };
  const handleBlockChange = (e) => {
    const selectedId = e.target.value;
    setSelectedBlockId(selectedId);
    setFormData((prevData) => ({
      ...prevData,
      blockId: selectedId,
    }));
  };
  const handleYearChange = (e) => {
    const selectedId = e.target.value;
    setSelectedYearId(selectedId);
    setFormData((prevData) => ({
      ...prevData,
      yearId: selectedId,
    }));
  };
  const handleCategoryChange = (e) => {
    const selectedId = e.target.value;
    setSelectedCategoryId(selectedId);
    setFormData((prevData) => ({
      ...prevData,
      categoryId: selectedId,
    }));
  };
  const handleSchemeChange = (e) => {
    const selectedId = e.target.value;
    setSelectedSchemesId(selectedId);
    setFormData((prevData) => ({
      ...prevData,
      schemeId: selectedId,
    }));
  };

  // Handle Edit
  const handleEditHouse = async (id) => {
    try {
      const response = await fetchHouseDetailById(id);
      setFormData(response.data);
      setSelectedPanchayatId(response.data.panchayatId);
      setSelectedBlockId(response.data.blockId);
      setSelectedCategoryId(response.data.categoryId);
      setSelectedYearId(response.data.yearId);
      setSelectedSchemesId(response.data.schemeId);
      setIsEditModalOpen(true);
    } catch (error) {
      console.error("Error fetching house detail:", error);
    }
  };

  const handleSaveEditHouse = async () => {
    if (!validateForm()) {
      return;
    }
    setIsEditModalOpen(false);
    setLoading(true);
    try {
      const response = await updateHouseDetail(formData.id, formData);
      console.log(response.data);

      setAlert({
        visible: true,
        message: "House detail updated successfully!",
        type: "success",
      });
      handleCancel();
      fetchHouseDetailsData();
    } catch (error) {
      console.error("Error updating house detail:", error);
      setAlert({
        visible: true,
        message: "Error adding house detail. Please try again.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle Delete
  const handleDeleteHouse = async () => {
    if (!houseToDelete) return;
    setIsDeleteModalOpen(false);
    setLoading(true);
    try {
      await deleteHouseDetail(houseToDelete.id);
      handleCancel();
      setAlert({
        visible: true,
        message: "House detail deleted successfully!",
        type: "success",
      });
      fetchHouseDetailsData();
    } catch (error) {
      console.error("Error deleting house detail:", error);
      setAlert({
        visible: true,
        message: "Error deleting house detail. Please try again.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setFormData({ name: "", activeStatus: true });
    setSelectedPanchayatId("");
  };

  const toggleViewModal = () => {
    setIsViewModalOpen(!isViewModalOpen);
    setViewBlockDetails(null);
  };

  const toggleEditModal = () => {
    setIsEditModalOpen(!isEditModalOpen);
    setEditBlock(null);
    setFormData({
      regNo: "",
      yearId: 0,
      schemeId: 0,
      blockId: 0,
      villageId: 0,
      panchayatId: 0,
      fatherorHusband: "",
      beneficiary: "",
      sanctionNo: "",
      categoryId: 0,
      releasedAmount: 0,
      installment: 0,
      creditDate: getCurrentDate(),
      houseStatusId: null,
      activeStatus: true,
    });
    setErrors({});
  };

  const toggleDeleteModal = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
    setBlockToDelete(null);
  };
  const handleCancel = () => {
    setFormData({
      regNo: "",
      yearId: 0,
      schemeId: 0,
      blockId: 0,
      villageId: 0,
      panchayatId: 0,
      fatherorHusband: "",
      beneficiary: "",
      sanctionNo: "",
      categoryId: 0,
      releasedAmount: 0,
      installment: 0,
      creditDate: getCurrentDate(),
      houseStatusId: null,
      activeStatus: true,
    });

    setIsEditModalOpen(false);
    setIsModalOpen(false);

    setIsDeleteModalOpen(false);
    setBlockToDelete(null);
    setErrors({});
  };
  return (
    <div className="houseState">
      {loading && <Loading />}
      {!loading && (
        <div className="houseState-container box-shadow">
          {alert.visible && (
            <AlertMsg
              message={alert.message}
              type={alert.type}
              onClose={() => setAlert({ ...alert, visible: false })}
            />
          )}
          <div className="container-head p-15">
            <h2>House Details</h2>
            <div className="btns">
              <span className="add-btn" onClick={handleMoveDetails}>
                <IoIosAddCircleOutline />
                <p>Add Details</p>
              </span>
            </div>
          </div>
          <div className="table-filters">
            <div className="search-filter">
              <label htmlFor="searchName">
                <FaSearch />
              </label>
              <input
                type="text"
                id="searchName"
                placeholder="Search by Beneficiary"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <div className="houseState-content" style={{ overflowX: "auto" }}>
            <div className="table-container">
              <table className="custom-table">
                <thead>
                  <tr>
                    <th>Reg. No</th>
                    <th
                      onClick={handleSortByName}
                      style={{ cursor: "pointer" }}
                    >
                      Beneficiary{" "}
                      {sortAscending ? (
                        <RiSortAlphabetAsc />
                      ) : (
                        <RiSortAlphabetDesc />
                      )}
                    </th>
                    <th>Father/Husband</th>
                    <th>Sanction No</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {getCurrentPageBlocks().length > 0 ? (
                    getCurrentPageBlocks().map((item) => (
                      <tr key={item.id}>
                        <td className="text-left">{item.regNo}</td>
                        <td className="text-left">{item.beneficiary}</td>
                        <td className="text-left">{item.fatherorHusband}</td>
                        <td className="text-left">{item.sanctionNo}</td>
                        <td className="text-center">
                          <p
                            className={
                              item.activeStatus ? "active" : "inactive"
                            }
                          >
                            {item.activeStatus ? "Active" : "Inactive"}
                          </p>
                        </td>
                        <td className="text-center">
                          <LuFileEdit
                            onClick={() => handleEditHouse(item.id)}
                          />
                          <FaRegTrashCan
                            onClick={() => {
                              setHouseToDelete(item);
                              setIsDeleteModalOpen(true);
                            }}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {pageCount > 1 && (
                <Pagination
                  currentPage={currentPage}
                  pageCount={pageCount}
                  setCurrentPage={setCurrentPage}
                />
              )}
            </div>
          </div>
        </div>
      )}

      {/* Edit House Modal */}
      {isEditModalOpen && (
        <div className="screen">
          <div className="screen-container">
            <div className="add-form-head">
              <h3>Edit House Details</h3>
              <span className="close-icon" onClick={toggleEditModal}>
                <ImCross />
              </span>
            </div>
            <div className="add-forms">
              <div className="add-form w-50">
                <label htmlFor="beneficiary">Beneficiary</label>
                <input
                  type="text"
                  name="beneficiary"
                  value={formData.beneficiary}
                  onChange={handleInputChange}
                  className={errors.beneficiary ? "input-error" : ""}
                />
              </div>
              <div className="add-form w-50">
                <label htmlFor="blockName">Block Name</label>
                <select
                  name="blockName"
                  value={selectedBlockId}
                  onChange={handleBlockChange}
                  className={errors.blockId ? "input-error" : ""}
                >
                  <option value="" disabled>
                    Select Block Name
                  </option>
                  {blockOptions.map((block) => (
                    <option key={block.id} value={block.id}>
                      {block.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="add-form w-50">
                <label htmlFor="yearName">Year</label>
                <select
                  name="yearName"
                  value={selectedYearId}
                  className={errors.yearId ? "input-error" : ""}
                  onChange={handleYearChange}
                >
                  <option value="" disabled>
                    Select Year
                  </option>
                  {yearOptions.map((year) => (
                    <option key={year.id} value={year.id}>
                      {year.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="add-form w-50">
                <label htmlFor="categoryName">Category Name</label>
                <select
                  name="categoryName"
                  value={selectedCategoryId}
                  className={errors.categoryId ? "input-error" : ""}
                  onChange={handleCategoryChange}
                >
                  <option value="" disabled>
                    Select Category Name
                  </option>
                  {categoryOptions.map((category) => (
                    <option key={category.id} value={category.id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="add-form w-50">
                <label htmlFor="panchayatName">Panchayat Name</label>
                <select
                  name="panchayatName"
                  value={selectedPanchayatId}
                  onChange={handlePanchayatChange}
                  className={errors.panchayatId ? "input-error" : ""}
                >
                  <option value="" disabled>
                    Select Panchayat Name
                  </option>
                  {panchayatOptions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="add-form w-50">
                <label htmlFor="fatherorHusband">Father/Husband</label>
                <input
                  type="text"
                  name="fatherorHusband"
                  value={formData.fatherorHusband}
                  onChange={handleInputChange}
                  className={errors.fatherorHusband ? "input-error" : ""}
                />
              </div>
              <div className="add-form w-50">
                <label htmlFor="sanctionNo">Sanction No</label>
                <input
                  type="text"
                  name="sanctionNo"
                  value={formData.sanctionNo}
                  onChange={handleInputChange}
                  className={errors.sanctionNo ? "input-error" : ""}
                />
              </div>
              <div className="add-form w-50">
                <label htmlFor="activeStatus">Active Status:</label>
                <div className=" custom-radio-group">
                  <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={true}
                      checked={formData.activeStatus === true}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Active
                  </label>
                  <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={false}
                      checked={formData.activeStatus === false}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Inactive
                  </label>
                </div>
              </div>
              <div className="add-form w-50">
                <label htmlFor="scheme">Scheme Name</label>
                <select
                  name="schemeName"
                  value={selectedSchemesId}
                  onChange={handleSchemeChange}
                  className={errors.schemeId ? "input-error" : ""}
                >
                  <option value="" disabled>
                    Select Scheme Name
                  </option>
                  {schemesOptions.map((scheme) => (
                    <option key={scheme.id} value={scheme.id}>
                      {scheme.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="btn-container">
                <div className="addforbtns">
                  <button className="btn-cancel" onClick={toggleEditModal}>
                    Cancel
                  </button>
                  <button
                    className="btn"
                    onClick={handleSaveEditHouse}
                    disabled={isLoading}
                  >
                    {isLoading ? "Saving..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <div className="screen">
          <div className="screen-container delete-popup">
            <h2>Are you sure you want to delete this house?</h2>
            <p>This action cannot be undone.</p>
            <button
              onClick={handleDeleteHouse}
              className="delete btn"
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Yes, Delete"}
            </button>
            <button className="btn-cancel" onClick={toggleDeleteModal}>
              No, Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HouseDetails;
